<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import Swal from "sweetalert2";
import medicionAusentismoAPI from "@/services/standards/medicionAusentismo/medicionAusentismoAPI";
import { dateFormatYear } from "@/utils/helpers/format";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import ItemAPI from "@/services/items/itemsAPI";
import CheckModal from "@/components/CheckModal";
import MedicionAusentismoFichaPagination from "../../../components/standard/medicionAusentismo/MedicionAusentismoFichaPagination.vue";
import DocumentActions from "@/components/document/DocumentActions.vue";
import ausentismoReportAPI from "@/services/standards/medicionAusentismo/ausentismoReportAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "Medición del ausentismo por causa médica",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    CheckModal,
    Layout,
    Style,
    PageHeader,
    MedicionAusentismoFichaPagination,
    DocumentActions,
  },
  data() {
    return {
      title: "3.3.6 Medición del ausentismo por causa médica",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Medición",
          active: true,
        },
      ],

      itemData: null,
      item: null,
      search: "",
      itemStatus: "No cumplido",
      deleteCount: 0,
      submitted: false,
      loading: true,
      years: [],
      lista: [],
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      numero: null,
      numero2: null,
      reportYear: new Date().getFullYear(),
      reportStatus: {
        medico: { status: "draft", signedAt: null },
        otras: { status: "draft", signedAt: null },
        consolidado: { status: "draft", signedAt: null },
      },
      medicion: {
        annual_goal: this.numero,
        monthly_goal: this.numero2,
        annual_period: 1,
        year: null,
        people_know_result: null,
        responsible_measurement: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
    };
  },
  computed: {
    reportYears() {
      const current = new Date().getFullYear() + 1;
      const arr = [];
      for (let y = current; y >= 2019; y--) arr.push(y);
      return arr;
    },
    medicoApi() {
      return {
        pdfUrl: (year) => ausentismoReportAPI.pdfUrl("medico", this.companyID, year),
        sign: (year, payload) => ausentismoReportAPI.sign("medico", this.companyID, year, payload),
      };
    },
    otrasApi() {
      return {
        pdfUrl: (year) => ausentismoReportAPI.pdfUrl("otras", this.companyID, year),
        sign: (year, payload) => ausentismoReportAPI.sign("otras", this.companyID, year, payload),
      };
    },
    consolidadoApi() {
      return {
        pdfUrl: (year) => ausentismoReportAPI.pdfUrl("consolidado", this.companyID, year),
        sign: (year, payload) => ausentismoReportAPI.sign("consolidado", this.companyID, year, payload),
      };
    },
  },
  watch: {
    reportYear() {
      this.fetchReportStatus();
    },
  },
  methods: {
    goRegistroMedico() {
      this.$bvModal.hide("registroAusentismoModal");
      this.goPage(`/forms/estandares/${this.companyID}/medicion-ausentismo-registro`);
    },
    goRegistroOtras() {
      this.$bvModal.hide("registroAusentismoModal");
      this.goPage(`/forms/estandares/${this.companyID}/medicion-ausentismo-otras`);
    },
    fetchReportStatus() {
      ["medico", "otras", "consolidado"].forEach((type) => {
        ausentismoReportAPI.status(type, this.companyID, this.reportYear)
          .then((r) => {
            if (!r) return;
            this.reportStatus[type] = { status: r.workflow_status || "draft", signedAt: r.signed_at || null };
          })
          .catch((e) => console.log(e));
      });
    },
    onReportSigned(type, payload) {
      this.reportStatus[type] = { status: payload.workflow_status, signedAt: payload.signed_at };
    },
    validarNumero() {
      if (this.numero <= 0) {
        this.numero = 0;
      } else if (this.numero > 100) {
        this.numero = 100;
      }
      if (this.numero !== null) {
        const numeroString = this.numero.toString().substring(0, 3);
        this.numero = parseInt(numeroString);
      }
      this.medicion.annual_goal = this.numero
    },
    validarNumero2() {
      if (this.numero2 <= 0) {
        this.numero2 = 0;
      } else if (this.numero2 > 100) {
        this.numero2 = 100;
      }
      if (this.numero2 !== null) {
        const numeroString = this.numero2.toString().substring(0, 3);
        this.numero2 = parseInt(numeroString);
      }
      this.medicion.monthly_goal = this.numero2
    },
    validarTecla(event) {
      const keyCode = event.keyCode || event.which;
      if (
        (keyCode >= 48 && keyCode <= 57) || // Números del teclado alfanumérico
        (keyCode >= 96 && keyCode <= 105) || // Números del teclado numérico
        keyCode === 8 // Tecla de retroceso
      ) {
        // Permitir la tecla
      } else {
        // Prevenir la tecla si no es válida
        event.preventDefault();
      }
    },
    fetch() {
      this.$refs.paginator.query();
    },

    getItemData() {
      ItemAPI.getItems(40)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 40)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
          if (this.itemStatus === 'No aplica') {
            this.itemStatus = 'No cumplido';
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 40,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            style: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            style: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },

    save() {
      this.submitted = true
      this.loading = true
      medicionAusentismoAPI
        .saveF(this.medicion)
        .then((response) => {
          const itemChange = {
            companies_id: this.companyID,
            item_id: 40,
            status: 'Pendiente',
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "¡Éxito!",
                  text: "¡Se ha registrado con éxito!",
                  type: "success",
                  icon: "success",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 2000);
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    deleteR(id) {
      medicionAusentismoAPI.delete(id)
        .then((response) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 40,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              setTimeout(() => {
                Swal.fire({
                  title: "¡Éxito!",
                  text: "¡Informacion eliminada con éxito!",
                  type: "success",
                  icon: "success",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });

        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      medicionAusentismoAPI
        .getF(this.companyID)
        .then((response) => {
          this.lista = response.data.data;
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    dateConvert(date) {
      return dateFormatYear(date);
    },

    rangeYear() {
      const max = 2040;
      const min = 2019;
      for (let i = min; i <= max; i++) {
        this.years.push(i);
      }
      return this.years
    },

    goPage(page) {
      window.location.href = page;
    },

    goBack() {
      this.$router.go(-1);
    },
  },

  mounted() {
    this.rangeYear();
    this.getList();
    this.getItems();
    this.getItemData();
    this.fetchReportStatus();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12 m-0 p-0" v-if="!loading">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <CheckModal>
                  <p class="text-justify">
                    Este indicador mide la pérdida de días programados de trabajo en el mes por incapacidad médica.
                  </p>
                  <p class="text-justify">
                    Los días programados de trabajo al mes corresponden a la cantidad de días laborales en el mes por el
                    número de trabajadores.
                  </p>
                  <p class="text-justify">
                    El responsable de la implementación deberá definir la meta mensual y anual, además el responsable de
                    la medición y las personas que deben conocer el resultado.
                  </p>
                </CheckModal>
              </div>

              <div class="form-row col-md-6 col-sm-12 pt-1">
                <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                  <b-form-select v-on:change="changeItemStatus(itemStatus)"
                    :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                    class="selectpicker form-control" v-model="itemStatus">
                    <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                    <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                    <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </div>

              <div class="col-md-6 text-right m-b-0"></div>

              <div class="col-md-6 text-right m-b-0 mt-1">
                <button v-b-modal.registroAusentismoModal class="btn btn-primary mx-1">
                  <span class="btn-label"> </span> Registrar ausentismo
                </button>
                <button @click="goPage(`/forms/estandares/${companyID}/medicion-ausentismo-grafica`)" class="btn btn-primary mx-1">
                  <span class="btn-label"> </span> Reporte (gráfica)
                </button>
              </div>
            </div>

            <!-- Selector: tipo de ausentismo a registrar -->
            <b-modal id="registroAusentismoModal" title="Registrar ausentismo" hide-footer size="md">
              <p class="text-muted small">Selecciona el tipo de ausentismo a registrar:</p>
              <div class="d-flex flex-column">
                <button class="btn btn-outline-primary mb-2 text-left" @click="goRegistroMedico">
                  <i class="mdi mdi-medical-bag mr-1"></i> <strong>Por causa médica</strong>
                  <div class="small text-muted">Incapacidades (accidente de trabajo, enfermedad general/laboral) con código diagnóstico.</div>
                </button>
                <button class="btn btn-outline-primary text-left" @click="goRegistroOtras">
                  <i class="mdi mdi-calendar-remove mr-1"></i> <strong>Por otras causas</strong>
                  <div class="small text-muted">Permisos, licencias, calamidad, ausencias injustificadas, sanciones, comisiones, etc.</div>
                </button>
              </div>
            </b-modal>

            <!-- Reportes firmables (PDF branded) -->
            <div class="card border mt-2" v-if="getRole('Consultar')">
              <div class="card-body py-3">
                <div class="d-flex align-items-center justify-content-between flex-wrap">
                  <h6 class="mb-0"><i class="mdi mdi-file-pdf-box text-danger"></i> Reportes firmables (PDF)</h6>
                  <b-form-group class="mb-0" label="Año del reporte" label-cols="auto" label-class="pt-1 pr-2">
                    <b-form-select v-model="reportYear" plain class="form-control form-control-sm" style="width:auto;">
                      <b-form-select-option v-for="y in reportYears" :key="y" :value="y">{{ y }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
                <div class="row mt-3">
                  <div class="col-md-4">
                    <h6 class="text-muted small mb-1">Causa médica</h6>
                    <DocumentActions :document-id="reportYear" :company-id="companyID"
                      :workflow-status="reportStatus.medico.status" :signed-at="reportStatus.medico.signedAt"
                      :api-service="medicoApi" document-title="Reporte de Ausentismo por Causa Médica" signer-role="gerente"
                      @signed="(p) => onReportSigned('medico', p)" />
                  </div>
                  <div class="col-md-4">
                    <h6 class="text-muted small mb-1">Otras causas</h6>
                    <DocumentActions :document-id="reportYear" :company-id="companyID"
                      :workflow-status="reportStatus.otras.status" :signed-at="reportStatus.otras.signedAt"
                      :api-service="otrasApi" document-title="Reporte de Ausentismo por Otras Causas" signer-role="gerente"
                      @signed="(p) => onReportSigned('otras', p)" />
                  </div>
                  <div class="col-md-4">
                    <h6 class="text-muted small mb-1">Consolidado</h6>
                    <DocumentActions :document-id="reportYear" :company-id="companyID"
                      :workflow-status="reportStatus.consolidado.status" :signed-at="reportStatus.consolidado.signedAt"
                      :api-service="consolidadoApi" document-title="Reporte Consolidado de Ausentismo" signer-role="gerente"
                      @signed="(p) => onReportSigned('consolidado', p)" />
                  </div>
                </div>
              </div>
            </div>

            <hr />

            <form class="form-group" @submit.prevent="save">
              <div class="table-responsive px-4 mt-2" v-if="getRole('Consultar')">
                <table class="table-sm pt-2 table border-bottom divide-y divide-gray-200 table-bordered rounded">
                  <thead class="bg-primary text-light">
                    <tr>
                      <th class="text-center align-middle" colspan="4">
                        Ficha tecnica del indicador
                      </th>
                    </tr>
                    <tr>
                      <th class="text-center align-middle">Nombre indicador</th>
                      <th class="text-center align-middle" colspan="3">
                        Medición del ausentismo por causa médica
                      </th>
                    </tr>
                  </thead>
                  <tbody class="">
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Formula</b>
                      </td>
                      <td class="text-center align-middle" colspan="3">
                        (Número de días de ausencia por incapacidad laboral y común / Número de días de trabajo
                        programados) * 100
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Intrerpretación del indicador</b>
                      </td>
                      <td class="text-center align-middle" colspan="3">
                        En el mes X se perdió x% de días de trabajo programados
                        por incapacidad médica
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b> Meta</b>
                      </td>
                      <td class="text-center align-middle">
                        <b-form-input class="col-md-4" type="text" id="date_exam" v-model="numero"
                          @keydown="validarTecla" @input="validarNumero" maxlength="3">
                        </b-form-input>
                      </td>

                      <td class="text-center align-middle">
                        <b-form-input class="col-md-4" type="text" id="date_exam" v-model="numero2"
                          @keydown="validarTecla" @input="validarNumero2" maxlength="3">
                        </b-form-input>
                      </td>
                      <td class="text-center align-middle">
                        <select required class="col-md-8 form-control" v-model="medicion.year">
                          <b-form-select-option v-for="item in years" :value="item">
                            {{ item }}
                          </b-form-select-option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b> Periocidad</b>
                      </td>
                      <td class="text-center align-middle" colspan="1">
                        Mensual
                      </td>

                      <td class="text-center align-middle" colspan="1">
                        Anual
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Fuente de la información</b>
                      </td>
                      <td class="align-middle" colspan="3">
                        <p>Incapacidades por eventos de tipo común</p>
                        <p>Incapacidades por eventos de tipo laboral</p>
                        <p>Número de días laborados en el mes</p>
                        <p>Número de trabajadores en el mes</p>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b> Personas que deben conocer el resultado</b>
                      </td>
                      <td class="text-center align-middle" colspan="3">
                        <b-form-input type="text" id="date_exam" maxlength="200" v-model="medicion.people_know_result">
                        </b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b> Responsable de la medición </b>
                      </td>
                      <td class="text-center align-middle" colspan="3">
                        <b-form-input type="text" id="date_exam" maxlength="200"
                          v-model="medicion.responsible_measurement">
                        </b-form-input>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="form-group text-right m-b-0 mt-3">
                  <button @click="" type="submit" name="boton" class="btn btn-primary" :disabled="submitted">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </div>

              <hr v-if="getRole('Consultar')" />

              <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                <div class="col-lg-12">
                  <div class="card-body">
                    <div class="row pb-3">
                      <div class="col-6">
                        <form @submit.prevent="fetch()" class="form-inline">
                          <div class="form-group mr-2">
                            <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                              class="form-control px-2" placeholder="Buscar"></b-form-input>

                            <div class="col-1">
                              <button type="submit" class="btn btn-primary px-2">
                                Buscar
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div class="col-6"></div>
                    </div>

                    <div class="table-responsive">
                      <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                        <thead>
                          <tr>
                            <th class="text-center align-middle">Año</th>
                            <th class="text-center align-middle">Meta anual</th>
                            <th class="text-center align-middle">
                              Personas que deben conocer el resultado
                            </th>
                            <th class="text-center align-middle">
                              Responsable de la medición
                            </th>
                            <th class="text-center align-middle">Acciones</th>
                          </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-gray-200">
                          <tr v-for="dato in lista" :key="dato.id">

                            <td class="text-center align-middle">
                              {{ dato.year }}
                            </td>
                            <td class="text-center align-middle">
                              {{ dato.annual_goal }}
                            </td>
                            <td class="text-center align-middle">
                              {{ dato.people_know_result }}
                            </td>
                            <td class="text-center align-middle">
                              {{ dato.responsible_measurement }}
                            </td>

                            <td class="text-center align-middle">
                              <div class="col-sm-12">
                                <b-dropdown variant="primary">
                                  <template v-slot:button-content>
                                    <i class="mdi mdi-eye"></i>
                                  </template>
                                  <b-dropdown-item :to="{
                                    path: `/forms/estandares/medicion-ficha-ver/${dato.id}`,
                                  }">
                                    Ver</b-dropdown-item>
                                  <b-dropdown-item @click="deleteR(dato.id)">
                                    Eliminar
                                  </b-dropdown-item>
                                </b-dropdown>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <MedicionAusentismoFichaPagination ref="paginator" :search="search"
                        @fetch="(items) => (lista = items)" />

                    </div>
                  </div>
                </div>
                <!-- end col -->
              </div>
            </form>
          </div>
        </div>
      </div>
      <div v-else class="col-xl-12 text-center">
        <div class="text-center">
          <b-spinner variant="primary" label="Loading..."></b-spinner>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
